/*============================================================================
  CRO kit finder
  Step 1 (procedure) -> Step 2 (timing) -> Result. Tapping an option advances.
==============================================================================*/
;(function () {
  function addBusinessDays(days) {
    const date = new Date()
    let added = 0
    while (added < days) {
      date.setDate(date.getDate() + 1)
      if (date.getDay() !== 0 && date.getDay() !== 6) added++
    }
    return date
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }

  class KitFinder {
    constructor(el) {
      this.el = el
      this.state = { procedure: null, timing: null }
      this.panels = el.querySelectorAll('[data-finder-panel]')
      this.stepLabel = el.querySelector('[data-finder-step-label]')
      this.progress = el.querySelector('[data-finder-progress]')

      el.addEventListener('click', this.onClick.bind(this))
      this.show(1, false)
    }

    onClick(evt) {
      const procedure = evt.target.closest('[data-finder-procedure]')
      const timing = evt.target.closest('[data-finder-timing]')
      const add = evt.target.closest('[data-finder-add]')

      if (procedure) {
        this.state.procedure = procedure
        this.el.querySelector('[data-finder-chip]').textContent = procedure.dataset.label
        this.show(2)
      } else if (timing) {
        this.state.timing = timing
        this.renderResult()
        this.show(3)
      } else if (evt.target.closest('[data-finder-back]')) {
        this.show(1)
      } else if (evt.target.closest('[data-finder-restart]')) {
        this.state = { procedure: null, timing: null }
        this.show(1)
      } else if (add) {
        this.addToCart(add)
      }
    }

    show(step, moveFocus = true) {
      this.el.dataset.step = step
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.finderPanel !== String(step)
      })

      const labels = { 1: this.el.dataset.labelFirst, 2: this.el.dataset.labelSecond, 3: this.el.dataset.labelDone }
      this.stepLabel.textContent = labels[step]
      this.progress.style.width = `${Math.round((step / 3) * 100)}%`

      // Mark the selected answers so Back shows what was picked
      this.el.querySelectorAll('[data-finder-procedure]').forEach((btn) => {
        btn.classList.toggle('is-selected', btn === this.state.procedure)
      })

      if (!moveFocus) return

      const panel = this.el.querySelector(`[data-finder-panel="${step}"]`)
      const heading = step === 3
        ? panel.querySelector('[data-finder-result]:not([hidden]) .cro-finder__heading')
        : panel.querySelector('.cro-finder__heading')
      if (heading) heading.focus({ preventScroll: true })

      const top = this.el.getBoundingClientRect().top
      if (top < 0) this.el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    renderResult() {
      const id = this.state.procedure.dataset.finderProcedure
      const timing = this.state.timing
      const min = parseInt(this.el.dataset.minDays, 10) || 0
      const max = Math.max(parseInt(this.el.dataset.maxDays, 10) || 0, min)
      const dates = `${formatDate(addBusinessDays(min))} to ${formatDate(addBusinessDays(max))}`

      this.el.querySelectorAll('[data-finder-result]').forEach((result) => {
        result.hidden = result.dataset.finderResult !== id
      })

      const result = this.el.querySelector(`[data-finder-result="${id}"]`)
      if (!result) return

      const box = result.querySelector('[data-finder-timing-box]')
      box.classList.toggle('is-urgent', timing.dataset.urgent === 'true')
      box.querySelector('[data-finder-timing-title]').textContent = timing.dataset.resultTitle
      box.querySelector('[data-finder-timing-text]').textContent = timing.dataset.resultText.replace('[dates]', dates)
    }

    async addToCart(btn) {
      btn.disabled = true
      btn.classList.add('btn--loading')

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: btn.dataset.finderAdd, quantity: 1 }] })
        })
        const data = await response.json()

        if (data.status === 422 || data.status === 'bad_request') {
          if (data.description) alert(data.description)
          return
        }

        if (window.theme?.settings?.cartType !== 'dropdown') {
          window.location.href = window.Shopify.routes.root + 'cart'
          return
        }

        // Rebuild and open the cart drawer (listeners in cart-form.js / cart-drawer.js)
        document.dispatchEvent(new CustomEvent('cart:build'))
        document.dispatchEvent(new CustomEvent('cart:open'))
      } catch (e) {
        console.error(e)
      } finally {
        btn.disabled = false
        btn.classList.remove('btn--loading')
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-cro-finder]').forEach((el) => {
      if (!el.kitFinder) el.kitFinder = new KitFinder(el)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  document.addEventListener('shopify:section:load', init)
})()
